import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProcessClaimModal from './components/ProcessClaimModal';

const ProcessClaimFullPage = () => {
  const [searchParams] = useSearchParams();

  const claim = useMemo(() => ({
    batch_no: searchParams.get('batch_no') || '',
    trans_no: searchParams.get('trn_no') || '',
    loa_no: searchParams.get('loa_no') || '',
  }), [searchParams]);
  const sourceTab = searchParams.get('source_tab') || null;
  const mode = searchParams.get('mode') || 'edit';

  const hasClaim = Boolean(claim.trans_no);

  if (!hasClaim) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
          <h2 className="text-lg font-semibold text-slate-800 mb-2">Missing Parameters</h2>
          <p className="text-sm text-slate-500">
            This page requires <strong>batch_no</strong>, <strong>trn_no</strong>, and <strong>loa_no</strong> query parameters.
          </p>
        </div>
      </div>
    );
  }

  return (
    <ProcessClaimModal
      isOpen={true}
      onClose={() => window.close()}
      claim={claim}
      mode={mode}
      showReturnButton={false}
      variant="fullpage"
      sourceTab={sourceTab}
    />
  );
};

export default ProcessClaimFullPage;
